import React from 'react';
import { useUrlBuilder } from '../../../../hooks/use-history-intercept';

interface PatientWidgetProps {
  url: string;
  iframeRef: React.MutableRefObject<HTMLIFrameElement>;
}

export default function MessengerWidget({ url, iframeRef }: PatientWidgetProps) {
  const { buildUrl } = useUrlBuilder();

  const handleOnLoad = () => {
    // this activates the widget frame if not it is blank
    // we delay 500ms to make sure the app can handle the event
    window.setTimeout(() => {
      iframeRef.current.contentWindow?.postMessage(
        {
          messageType: 'frame-activate',
          data: {
            frameName: 'messenger'
          }
        },
        '*'
      );
    }, 500);
  };
  return (
    <iframe
      id='messenger-widget'
      src={buildUrl(url)}
      ref={iframeRef}
      name='messenger-slideout'
      onLoad={handleOnLoad}
      style={{
        height: '100%!important',
        position: 'relative !important' as any,
        width: '100%!important',
        border: 'none'
      }}
    />
  );
}
